import React from 'react';
import styled from 'styled-components';
import {Button} from '@material-ui/core';
import { Link } from 'react-router-dom';
function Qualifications(){
  return(<Container>
    <Link to={'/'}>
    <Button>Back To Home</Button>
    </Link>
    <Link to="/mysite">
    <Button>About me</Button>
    </Link>
    <h1> Qualifications </h1>
    <Qual>
      <div class="box1">
        <h1>Primary edu</h1>
        <p> School:- Sri Chaitanya.</p>
        <p> Grade Points: 10</p>
      </div>
      <div class="box2">
        <h1>Under Graduation</h1>
        <p> University:- Amity University.</p>
        <p> Percentage:- In progress..</p>
      </div>
      <div class="box3">
        <h1>Secondary edu</h1>
        <p> College:- Vignan.</p>
        <p> Grade Points: 9.71</p>
      </div>
    </Qual>
    </Container>)
}

export default Qualifications;
const Container = styled.div`
  /* height:100vh; */
  background: linear-gradient(to right, #ddd6f3, #faaca8);
  Button{
    text-decoration: none;
    background: red;
    /* background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4); */
    /* background-size: 400%; */
    color: white;
    margin-top:30px;
    margin-left:20%;
    margin-right:20%;
    transform: translate(-50%,-50%);
    animation: animateDown infinite 1.5s;
    &:hover{
      background: black;
    }
  }
  h1{
    font-family: 'Grenze Gotisch', cursive;
    font-size:60px;
  }
`
const Qual = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  div{
    cursor: pointer;
    flex:1;
    border: 1px solid whitesmoke;
    padding: 0 30px;
    padding-bottom: 20px;
    border-radius: 20px;
    margin: 0 50px;
    margin-top: 50px;
    margin-bottom:85px;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
  rgb(0 0 0 / 73%) 0px 16px 10px -10px;

  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  /* transform: translate(-50%,-50%); */
  &:hover{
    box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
    rgb(0 0 0 / 72%) 0px 30px 22px -10px;
    border-color: rgba(249, 249, 249, 0.8);
    transform: scale(1.05);
    background-color: white;

  }

  }
  .box1{
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    animation: animateDown infinite 1.5s;
  }
  .box3{
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    animation: animateDown infinite 1.5s;
  }
  .box2{
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    animation: animateUp infinite 1.5s;
  }
`
